
  export const getUserName = (resultHandler, snackbar) => {
    let whoamiAPI = "/api/whoami";
    if (process.env.NODE_ENV !== "production") {
      whoamiAPI = "http://localhost:7071" + whoamiAPI;
    }
    fetch(whoamiAPI, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (!response.ok) {
        if (response.status == 401) {
          window.location.href = "/.auth/login/google?access_type=offline&redirect_uri=https://" + window.location.host + "/.auth/login/google/callback";
        }
        response
          .text()
          .then((text) => {
            throw Error(response.statusText + ": " + text);
          })
          .catch((error) =>
            snackbar(error.message, { variant: "error" })
          );
      } else {
        response.json().then((result) => {
          // this.setState({ userName: result.userName });
          resultHandler(result.userName);
        });
      }
    });
  };

export const updateGoogleTokens = (resultHandler) => {
    let authPack = null;
    getAuthPackage((result) => {
        if (result) {
            authPack = result[0];
            let api = "/api/accessToken";
            if (process.env.NODE_ENV !== "production") {
                api = "http://localhost:7071" + api;
            }
            fetch(api, {
                method: "post",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(authPack),
            }).then((response) => {
                if (!response.ok) {
                    if (response.status == 401) {
                        window.location.href = "/.auth/login/google?access_type=offline&redirect_uri=https://" + window.location.host + "/.auth/login/google/callback";
                    }
                    response
                        .text()
                        .then((text) => {
                            throw Error(response.statusText + ": " + text);
                        });
                } else {
                    response.json().then((result) => {
                        resultHandler();
                    });
                }
            });
        }
    });

}

const getAuthPackage = (resultHandler) => {
    let googleCredential = "/.auth/me";
    if (process.env.NODE_ENV !== "production") {
        googleCredential = "https://evasandbox.azurewebsites.net/.auth/me";
    }
    fetch(googleCredential, {
        method: "GET",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
        },
    }).then((response) => {
        if (!response.ok) {
            response
                .text()
                .then((text) => {
                    throw Error(response.statusText + ": " + text);
                })
                .catch();
        } else {
            response.json().then((result) => {
                resultHandler(result);
            });
        }
    });
};